import HttpFactory from '../factory'
import type { IPractitionerPatientsCounterDto } from '../types/tasks'

class TasksModule extends HttpFactory<any[]> {
  private COUNTER_PATH = '/tasks-counters/patients'
  private COUNTER_PATH_V2 = '/v2/tasks-counters/patients'
  private COUNTER_PATH_TASK = '/tasks'
  private SCHEDULED_TASK_PATH = '/scheduled-tasks'
  async getPractitionerTaskCount(): Promise<IPractitionerPatientsCounterDto[]> {
    let arr: IPractitionerPatientsCounterDto[] = []
    let nextPageUrl = '?pageSize=1000'

    do {
      await this.call<any>('GET', `${this.COUNTER_PATH_V2}/${nextPageUrl}`).then((response) => {
        arr = arr.concat(response.items)
        nextPageUrl = response.nextPageUrl
      })
    } while (nextPageUrl)
    return arr
  }

  async getTasks(
    id: string,
    forRequester: boolean = false,
    pageSize: number = 200,
    nextPageUrl?: string,
  ): Promise<TasksModule[]> {
    let queryParams = `?pageSize=${pageSize}&forMe=${forRequester}`
    if (forRequester) {
      if (nextPageUrl) {
        const modifiedUrl = nextPageUrl.replace(/pageSize=\d+/, `pageSize=${pageSize}`)
        return await this.call<any>('GET', `${this.COUNTER_PATH_TASK}/${modifiedUrl}`)
      }
      return await this.call<any>('GET', `${this.COUNTER_PATH_TASK}/${queryParams}`)
    }
    if (nextPageUrl) {
      const modifiedUrl = nextPageUrl.replace(/pageSize=\d+/, `pageSize=${pageSize}`)
      return await this.call<any>('GET', `${this.COUNTER_PATH_TASK}/${modifiedUrl}`)
    }
    return await this.call<any>('GET', `${this.COUNTER_PATH_TASK}/${queryParams}&patientId=${id}`)
  }

  async getScheduledTasks(patientId: string): Promise<TasksModule[]> {
    return await this.call<any>('GET', `${this.SCHEDULED_TASK_PATH}?patientId=${patientId}&pageSize=200`)
  }

  async getScheduledTaskById(taskId: string): Promise<any> {
    return await this.call<any>('GET', `${this.SCHEDULED_TASK_PATH}/${taskId}`)
  }

  async postScheduledTask(data: any): Promise<any> {
    return await this.call<any>('POST', `${this.SCHEDULED_TASK_PATH}?createFirstTask=true`, data)
  }

  async updateScheduledTask(taskId: string, revisionId: string, data: any): Promise<any> {
    return await this.call<any>('PATCH', `${this.SCHEDULED_TASK_PATH}/${taskId}?revision=${revisionId}`, data)
  }

  async deleteScheduledTask(taskId: string): Promise<any> {
    return await this.call<any>('DELETE', `${this.SCHEDULED_TASK_PATH}/${taskId}`)
  }

  async postTaskActions(taskId: string, actionId: string, revisionId: string, data: any): Promise<any> {
    return await this.call<any>(
      'PATCH',
      `${this.COUNTER_PATH_TASK}/${taskId}/actions/${actionId}?revision=${revisionId}`,
      data,
    )
  }

  async postTask(data: any): Promise<any> {
    return await this.call<any>('POST', `${this.COUNTER_PATH_TASK}`, data)
  }

  async updateTask(taskId: string, revisionId: string, data: any): Promise<any> {
    return await this.call<any>('PATCH', `${this.COUNTER_PATH_TASK}/${taskId}?revision=${revisionId}`, data)
  }

  async getTaskById(taskId: string): Promise<any> {
    return await this.call<any>('GET', `${this.COUNTER_PATH_TASK}/${taskId}`)
  }
}

export default TasksModule
